import { useEffect, useState } from "react";
import "../App.css";
import { FaInstagram } from "react-icons/fa";
import { client } from "../../sanity/client";
import { useParams } from "react-router-dom";

function Creator() {
  const [creator, setCreator] = useState([]);
  const { creatorUrl } = useParams();
  useEffect(() => {
    const fetchCreator = async () => {
      try {
        const links = await client.fetch(
          `*[_type == "creators" && cardUrl == $creatorUrl] {profileName, skill, profileImageUrl, bio, instagram, spotifyUrl, youtubeUrl}`,
          { creatorUrl: `/${creatorUrl}` }
        );
        setCreator(links);
      } catch (error) {
        console.error("Error fetching Creator:", error);
      }
    };

    fetchCreator();
  }, [creatorUrl]);

  function formatBio(text) {
    const sentences = text.split(/(?<=\.)/);

    let result = [];
    sentences.forEach((sentence, index) => {
      result.push(sentence.trim());
      if ((index + 1) % 2 === 0 && index !== sentences.length - 1) {
        result.push(<br key={`br-${index}`} />);
        result.push(<br key={`br2-${index}`} />);
      } else {
        result.push(" ");
      }
    });

    return result;
  }

  if (!creator) return <p>Loading...</p>;

  return (
    <>
      {creator.map((creator) => (
        <div className="min-h-[100vh]" key={creator.profileName}>
          <div className="flex__layout">
            <div className="artist__description" data-aos="fade-down">
              <h1 className="text-4xl">{creator.profileName}</h1>
              <br />
              <h3 className="text-3xl italic">{creator.skill}</h3>
              <br />
              <p>{formatBio(creator.bio)}</p>

              {creator.instagram && (
                <div className="social__media__icons">
                  <li>
                    <a
                      href={creator.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <p>
                        <FaInstagram fill="black" size={40} />
                      </p>
                    </a>
                  </li>
                </div>
              )}
            </div>

            <div>
              <div className="__photos" data-aos="fade-up">
                <img
                  src={creator.profileImageUrl}
                  alt={creator.profileName}
                  className="artists__photo__size"
                />
              </div>
            </div>
          </div>

          {/*Spotify List Embed*/}
          {creator.spotifyUrl && (
            <div className="flex justify-center pt-10" data-aos="fade-in">
              <iframe
                title={`${creator.profileName} Spotify playlist`}
                src={creator.spotifyUrl}
                className="w-[90%] max-w-[800px] h-[380px]"
                frameBorder="0"
                allowFullScreen
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              ></iframe>
            </div>
          )}
          {/*Youtube Video Embed*/}
          {creator.youtubeUrl && (
            <div className="flex justify-center my-10" data-aos="fade-in">
              <iframe
                className="w-[90%] max-w-[800px] h-[400px]"
                src={creator.youtubeUrl}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          )}
        </div>
      ))}
    </>
  );
}

export default Creator;
